import { cutoffForm } from "./cutoff-form.js";
import { V } from "../../app/pages.js";
import { can, emp, me, uname } from "../../services/access.js";
import { sitePicker } from "../sites/components.js";
import { S } from "../../app/store.js";
import { RULES, runTot, sitePayroll } from "../../domain/payroll.js";
import { inSite, projectSite, selectedSite, siteName } from "../sites/model.js";
import { fmtD } from "../../domain/dates.js";
import { esc, peso } from "../../domain/format.js";
import { ssn } from "../../components/ui.js";
import { piecePanel, integrationPanel } from "../hrm/foundation.js";

V.payroll = () => {
  const u = me(),
    show = can("hr.salary") || can("pay.approve");
  const runs = S.runs
      .slice()
      .reverse()
      .map((original) => {
        const r = {
          ...original,
          lines: sitePayroll(original).filter((l) => inSite(l.project)),
        };
        if (!r.lines.length) return "";
        const t = runTot(r);
        let act = "";
        if (
          selectedSite() === "ALL" &&
          r.status === "DRAFT" &&
          can("pay.approve")
        )
          act =
            r.by === u.id
              ? `<span class="small muted">You prepared this run</span>`
              : `<button class="pri" data-act="pr-ok" data-id="${r.id}">Approve & post accrual</button>`;
        if (
          selectedSite() === "ALL" &&
          r.status === "APPROVED" &&
          can("pay.release")
        )
          act = `<button class="pri" data-act="pr-rel" data-id="${r.id}">Release net pay</button>`;
        if (
          selectedSite() === "ALL" &&
          r.status === "DRAFT" &&
          can("pay.prepare")
        )
          act += ` <button data-act="pr-recalc" data-id="${r.id}">Recompute</button>`;
        return `<section class="panel"><div class="panel-h"><div><h2>${r.id} · ${fmtD(r.from)} – ${fmtD(r.to)}</h2><span class="small muted">Semi-monthly · pay date ${fmtD(r.pay)} · prepared by ${esc(uname(r.by))}${r.ap ? " · approved by " + esc(uname(r.ap)) : ""}</span></div><div class="row">${ssn(r.status)} ${act}</div></div>
    <div class="tbl"><table><thead><tr><th>Employee</th><th class="n">Gross pay</th><th class="n">SSS</th><th class="n">PhilHealth</th><th class="n">Pag-IBIG</th><th class="n">W/tax</th><th class="n">Allowances</th><th class="n">Net pay</th><th class="n">Employer share</th></tr></thead><tbody>
    ${r.lines.map((l) => `<tr><td>${esc(emp(l.emp).name)}<div class="small muted">${esc(siteName(projectSite(l.project)))}${l.project ? " · " + esc(l.project) : ""}</div>${l.field ? `<div class="small muted">${l.worked} days on site${l.mwe ? " · minimum wage earner, no tax" : ""}</div>` : ""}</td>${show ? ["gross", "sssEE", "phEE", "hdEE", "tax", "allow", "net", "er"].map((k) => `<td class="n">${peso(l[k])}</td>`).join("") : `<td class="n" colspan="8">•••• salary detail hidden for this role</td>`}</tr>`).join("")}
    </tbody><tfoot><tr><td>Totals</td>${["gross", "sssEE", "phEE", "hdEE", "tax", "allow", "net", "er"].map((k) => `<td class="n">${peso(t[k])}</td>`).join("")}</tr></tfoot></table></div></section>`;
      })
      .join("");
  const emptyTitle = !S.runs.length
    ? "No payroll runs yet"
    : selectedSite() === "ALL"
      ? "No payable entries in these runs"
      : "No payroll entries for this location";
  const emptyMessage = !S.runs.length
    ? "Create a payroll cutoff to prepare the first run. Add employees or record site work before calculating pay."
    : selectedSite() === "ALL"
      ? "Add employees or approved site work, then recompute the payroll run."
      : "Choose another site or All locations to view its payroll entries.";
  const empty = `<section class="payroll-empty" aria-labelledby="payroll-empty-title"><h2 id="payroll-empty-title">${emptyTitle}</h2><p>${emptyMessage}</p>${!S.runs.length && can("hr.salary") ? '<button class="out" data-go="people">Open employees</button>' : ""}</section>`;
  const ruleCards = [
    ["SSS & EC", RULES.sss],
    ["PhilHealth", RULES.phic],
    ["Pag-IBIG", RULES.hdmf],
    ["Withholding tax", RULES.wtc],
  ];
  return (
    `<div class="page-toolbar">${sitePicker()}${cutoffForm()}</div>` +
    (runs || empty) + piecePanel() + integrationPanel() +
    `<details class="payroll-rules">
      <summary><span class="payroll-rules-heading"><strong>Payroll calculation rules</strong><span>Contributions, site pay and ledger posting</span></span><span class="payroll-rules-chevron" aria-hidden="true"></span></summary>
      <div class="payroll-rules-body">
        <div class="payroll-rules-grid">${ruleCards.map(([title, detail]) => `<section class="payroll-rule-card"><h3>${title}</h3><p>${esc(detail)}</p></section>`).join("")}</div>
        <div class="payroll-rules-flow">
          <div><strong>Two cutoffs</strong><span>Contributions are split evenly across both cutoffs.</span></div>
          <div><strong>Site pay</strong><span>Daily time records determine daily or piece rates, premiums, site allowances and the site's minimum wage by date.</span></div>
          <div><strong>Ledger posting</strong><span>Approval posts the accrual. Release posts net pay against Cash in Bank.</span></div>
        </div>
      </div>
    </details>`
  );
};
